import React, { useMemo } from 'react';
import { View } from 'react-native';
import lodashIsEmpty from 'lodash/isEmpty';

import TagIconList from '../../Service/TagIconList';

import Badge from '../Badge';

type Props = {
  stock: number;
  style?: any;
  tags: string[];
  tagLimit?: -1 | number; // -1 no limit
};
type TagIcon = {
  id: string;
  name: string;
  type: string;
  category: string;
  icon: string;
};
const ItemTag: React.FC = ({ stock, style, tagLimit = 1, tags }: Props) => {
  const displayTags = tagLimit === -1 ? tags : tags.slice(0, tagLimit);
  const noStock = stock === 0;
  const data = useMemo(
    () => (noStock ? [...displayTags, 'unavailable'] : displayTags),
    [displayTags, noStock],
  );
  if (lodashIsEmpty(data)) return null;
  return data.map((tag) => {
    const result = TagIconList.getTagIcon(tag) as TagIcon;
    return (
      <View key={result.id} style={style}>
        {/* @ts-ignore: Badge is not typescript component yet */}
        <Badge type={result.type} category={result.category} size="c2">
          {`${result.icon ? `${result.icon} ` : ''}${result.name}`}
        </Badge>
      </View>
    );
  });
};

export default ItemTag;
